import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SecureRoutingModule } from "./secure-routing.module";
import { LayoutModule } from "@angular/cdk/layout";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatButtonModule } from "@angular/material/button";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatIconModule } from "@angular/material/icon";
import { MatListModule } from "@angular/material/list";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { FooterModule } from "../_shared/footer/footer.module";
import { SecureLayoutComponent } from "./layout/layout.component";
import { MatTabsModule } from "@angular/material/tabs";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { BreadCrumbModule } from "../_shared/bread-crumb/bread-crumb.module";

@NgModule({
  declarations: [SecureLayoutComponent],
  imports: [
    CommonModule,
    SecureRoutingModule,
    LayoutModule,
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    MatFormFieldModule,
    MatInputModule,
    MatMenuModule,
    FooterModule,
    MatTabsModule,
    ScrollingModule,
    BreadCrumbModule,
  ],
})
export class SecureModule {}
